/**
 * Handle Progress Bar
 */

import 'jquery-ui';
import { $window } from '../utils/globals.js';

const winH = $window.height();

const handleProgressBar = () => {
    $("#progressbar").progressbar({
    	value: 1
    });
}

const animateProgressBar = () => {
    $('#progressbar .ui-progressbar-value').animate(
        {
            width: 100 + '%'
        },
        {
            duration: 8000
        }
    );

    const activeClass = 'is-active';

    setTimeout(function() { $('.progress-bar__text li:nth-child(2)').addClass(activeClass).siblings().removeClass(activeClass);
    }, 1000);

    setTimeout(function() { $('.progress-bar__text li:nth-child(3)').addClass(activeClass).siblings().removeClass(activeClass);
    }, 2000);

    setTimeout(function() { $('.progress-bar__text li:nth-child(4)').addClass(activeClass).siblings().removeClass(activeClass);
    }, 3000);

    setTimeout(function() { $('.progress-bar__text li:nth-child(5)').addClass(activeClass).siblings().removeClass(activeClass);
    }, 4000);

    setTimeout(function() { $('.progress-bar__text li:nth-child(6)').addClass(activeClass).siblings().removeClass(activeClass);
    }, 5000);

    setTimeout(function() { $('.progress-bar__text li:nth-child(7)').addClass(activeClass).siblings().removeClass(activeClass);
    }, 6200);

    setTimeout(function() { $('.progress-bar__text li:nth-child(8)').addClass(activeClass).siblings().removeClass(activeClass);
    }, 7400);

    setTimeout(function() { $('.js-tile-overlay').addClass(activeClass);
    }, 8000);

}

handleProgressBar();

const animate = (winST) => {
    $('.js-progressbar').each(function(){
        const $this = $(this);

        if (winST + winH * 0.95 > $this.offset().top) {
            if ( !$this.hasClass('animated') ) {
                $this.addClass( 'animated' );

                setTimeout(function() {
                  animateProgressBar();
                }, 100);
            }
        }
    });
};

$window.on('load scroll', function() {
    let winST = $window.scrollTop();

    animate(winST);
});
